<template>

  <div class="ui segment form-segment">      

    <h4 class="ui dividing header">Solicitação de Exame</h4>
    
    <div class="m-b-20">
      <button class="ui mini basic button" @click="$refs.examRequestPicker.show()">
        <i class="search plus grey icon"></i> Selecionar
      </button>
      <button v-show="cert.examRequestId" class="ui mini basic button m-l-10" @click="onRemoveExamRequest()">
        <i class="times red icon"></i> Remover
      </button>        
    </div>

    <div v-if="cert.examRequestId" class="ui form animated fadeIn">
      <div class="fields">
        <div class="two wide field">
          <label class="form-label">Número</label>
          {{ cert.examRequest.id }}
        </div> 
        <div class="two wide field">
          <label class="form-label">Data</label>
          {{ $formatDate(cert.examRequest.date) }}
        </div>
        <div class="three wide field">
          <label class="form-label">Responsável</label>
          {{ cert.examRequest.user.name }}
        </div> 
        <div class="three wide field">
          <label class="form-label">Veterinário</label>
          {{ cert.examRequest.vetName }}
        </div> 
        <div class="three wide field">
          <label class="form-label">Clínica</label>
          {{ cert.examRequest.customerName }}
        </div> 
        <div class="three wide field">
          <label class="form-label">Animal</label>
          {{ cert.examRequest.animalName }}
        </div>      
      </div>
      <div class="fields">                       
        <div class="two wide field">
          <label class="form-label">
            Sexo
            <i v-if="cert.examRequest.animalSex == 'male'" class="mars blue icon"></i>
            <i v-if="cert.examRequest.animalSex == 'female'" class="venus pink icon"></i>
            <i v-if="cert.examRequest.animalSex == 'undefined'" class="question circle grey icon"></i>
          </label>
          <span v-if="cert.examRequest.animalSex == 'male'">Macho</span>
          <span v-if="cert.examRequest.animalSex == 'female'">Fêmea</span>
          <span v-if="cert.examRequest.animalSex == 'undefined'">Indefinido</span>
        </div>           
        <div class="two wide field">
          <label class="form-label">Raça</label>
          {{ cert.examRequest.raceName }}
        </div> 
        <div class="three wide field">
          <label class="form-label">Espécie</label>
          {{ cert.examRequest.speciesName }}
        </div> 
        <div class="three wide field">
          <label class="form-label">Idade</label>
          {{ cert.examRequest.animalAge }}
        </div> 
        <div class="three wide field">
          <label class="form-label">Tutor</label>
          {{ cert.examRequest.ownerName }}
        </div> 
        <div class="three wide field">
          <label class="form-label">Tipo do Exame</label>
          {{ cert.examType.description }}
        </div> 
      </div>
      <div class="fields">                
        <div class="sixteen wide field">
          <label class="form-label m-b-10">Suspeita Clínica</label>
          <span v-html="suspicion"></span>
        </div>
      </div>
    </div>

    <p v-show="!cert.examRequestId" class="grey text animated fadeIn m-t-30">
      <i class="info circle icon"></i> Nenhuma solicitação selecionada
    </p> 

    <exam-request-picker ref="examRequestPicker" @onPick="onPickExamRequest" />

  </div> 

</template>

<script>
  
  import replaceAll from "@/utils/replace-all"
  import { ExamRequestPicker, TextEditor } from "@/components"

  export default {
    
    name: "ExamRequestSegment",

    data() {
      return {
        cert: {
          examRequest: { user: {} },
          examType: {},
        },
      }
    },

    components: {
      ExamRequestPicker,
      TextEditor,
    },

    computed: {

      suspicion() {

        if (!this.cert.examRequest.suspicion)
          return ""

        return replaceAll(this.cert.examRequest.suspicion, "\n", "<br/>")  
      },
    },

    methods: {

      init(cert) {
        this.cert = this.$cloneObject(cert)
      },

      onPickExamRequest(request) {        
        this.cert.examRequestId = request.id
        this.cert.examTypeId = request.examType.id
        this.cert.examRequest = request
        this.cert.examType = request.examType        
        this.onChange()
      },

      onRemoveExamRequest(request) {
        this.cert.examRequestId = null
        this.cert.examTypeId = null
        this.cert.examRequest = { user: {} }
        this.cert.examType = {}
        this.onChange()
      },

      onChange() {
        this.cert = this.$cloneObject(this.cert)
        this.$emit("onChange", { examRequestId: this.cert.examRequestId, examTypeId: this.cert.examTypeId })
      },
    },
  }

</script>